import { render } from "./CreateDataForm.vue?vue&type=template&id=2a60b26e&scoped=true"
import script from "./CreateDataForm.vue?vue&type=script&lang=js"
export * from "./CreateDataForm.vue?vue&type=script&lang=js"

import "./CreateDataForm.vue?vue&type=style&index=0&id=2a60b26e&scoped=true&lang=css"
import "./CreateDataForm.vue?vue&type=style&index=1&id=2a60b26e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a60b26e"]])

export default __exports__